import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import type { PolicyRegulation } from '../../types/policy.types';

interface RegulationCitationProps {
  regulation: PolicyRegulation;
  size?: 'xs' | 'sm';
}

export default function RegulationCitation({
  regulation,
  size = 'sm',
}: RegulationCitationProps) {
  const sizingPadding = size === 'xs' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';
  const inner = (
    <>
      <span className="font-semibold">{regulation.jurisdiction}</span>
      <span className="text-gray-400">·</span>
      <span>{regulation.law}</span>
      {regulation.url && <ArrowTopRightOnSquareIcon className="h-3 w-3 text-gray-400" aria-hidden="true" />}
    </>
  );
  const baseClasses = `inline-flex items-center gap-1 rounded-md bg-gray-50 text-gray-700 ring-1 ring-inset ring-gray-200 ${sizingPadding}`;
  if (regulation.url) {
    return (
      <a
        href={regulation.url}
        target="_blank"
        rel="noopener noreferrer"
        title={regulation.citation}
        className={`${baseClasses} hover:bg-gray-100 hover:text-gray-900`}
      >
        {inner}
      </a>
    );
  }
  return (
    <span title={regulation.citation} className={baseClasses}>
      {inner}
    </span>
  );
}
